// Calculator input limits — single source of truth
export const LIMITS = {
  CORPUS_MIN: 100000,
  CORPUS_MAX: 1000000000,
  CORPUS_STEP: 100000,
  WITHDRAWAL_MIN: 0,
  WITHDRAWAL_MAX: 10000000,
  WITHDRAWAL_STEP: 5000,
  RETURN_MIN: 8,
  RETURN_MAX: 13,
  RETURN_STEP: 0.5,
  INFLATION_MIN: 5,
  INFLATION_MAX: 7,
  INFLATION_STEP: 0.5,
  TARGET_MIN: 0,
  TARGET_MAX: 15,
  TARGET_STEP: 1,
};

// Compact number thresholds
export const COMPACT_THRESHOLDS = {
  CRORE: 10000000,
  LAKH: 100000,
  THOUSAND: 1000,
};

// Default sustainability scan range
export const PERP_THRESHOLD = 500;
